/* Copyright (c) 2026 PearlCrm Pty Ltd. All rights reserved. */

import React from "react";
import MDBox from "components/MDBox";

export default function PresenceDot({ color, size = 10 }) {
  return (
    <MDBox
      sx={{ width: size, height: size, borderRadius: "50%", bgcolor: color, flexShrink: 0 }}
    />
  );
}
